import script from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"

import "./ProductsView.vue?vue&type=style&index=0&id=2999729e&lang=scss"

const __exports__ = script;

export default __exports__